import AcceptTerms from './AcceptTerms';

export default AcceptTerms;
